import { graphql } from 'react-relay';

export const documentsFragment = graphql`
  fragment Documents_component on Documents 
  @argumentDefinitions(
    salesAdmission: {type: "String"}
  ) {
      files(salesAdmission: $salesAdmission) {
        brochure {
          ...FileLink_fileLink
        }
        factsheet {
          ...FileLink_fileLink
        }
        kid {
          ...FileLink_fileLink
        }
        others {
          ...FileLink_fileLink
        }
      }
    infolinks {
      url
      ...InfoLink_infoLink
    }
  }
`;
